import { useTranslation } from "react-i18next";

import { useEffect, useState } from 'react';
import defaultImg from '../img/pse_jru.png';

export default function Product({name = "",description="",title2="",img = "", tansparent=false, new_product=false, catalog="",demo="",manual=""}) {
    const { t } = useTranslation();
    
    const [isSmall, setIsSmall] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleChange = () => setIsSmall(!mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
    }, []);

    var width = "calc( 50% + 320px )";
    var centerer= "";
    var l = "pl-2";
    if(isSmall){
        width = "100%";
        centerer = "text-center";
        l= "";
    }

    var image = defaultImg; //FALLBACK IMAGE
    if(img != ""){ image = img; }


    var img_style = "rounded-xl border border-gray-300";
    if(tansparent){
        img_style = "";
    }

    var tit2 = "";
    if(title2 != ""){
        tit2 = <h6 class="text-sm text-gray-700 fade-in-up">{title2}</h6>;
    }

    var link = ""

    var catalog_btn = ""
    if(catalog !== ""){
        link = catalog;
        catalog_btn = <a href={catalog} class="flex justify-center w-full m-2 px-3 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none">
                    {t("catalog_btn")}
                </a>;
    }

    var demo_btn = ""
    if(demo !== ""){
        link = demo;
        demo_btn = <a href={demo} class="flex justify-center w-full m-2 px-3 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none">
                    {t("demo_btn")}
                </a>;
    }

    var manual_btn = ""
    if(manual !== ""){
        link = manual;
        manual_btn = <a href={manual} class="flex justify-center w-full m-2 px-3 py-2 font-medium text-center text-white bg-orange-700 rounded-lg hover:bg-orange-800 focus:outline-none">
                    {t("manual_btn")}
                </a>;
    }

    var new_banner = ""
    if(new_product == true){
        new_banner = (
            <div class="w-full m-2 px-4 py-3 border border-orange-200 bg-orange-50 rounded-lg">
                <div class="flex items-center gap-3">
                    <div class="w-2 h-2 rounded-full bg-orange-500"></div>
                    <span class="text-sm font-medium text-orange-900">
                        {t("new")}
                    </span>
                </div>
            </div>
        );
    }

    return (
        <div class="flex flex-col m-5 max-w-xs bg-white border border-gray-200 rounded-lg shadow-sm bg-opacity-90">

            {link ? (
                <a class="mx-5 mt-5 flex overflow-hidden    " href={link}>
                    <img class={"object-cover " + img_style} src={image} width="500" height="600" alt="Product image" />
                </a>
            ) : (
                <div class="mx-5 mt-5 flex overflow-hidden    " href={link}>
                    <img class={"object-cover " + img_style} src={image} width="500" height="600" alt="Product image" />
                </div>
            )}

            {link ? (
                <a href={link} className="px-5 pt-3">
                    <h5 className="text-2xl font-bold tracking-tight text-gray-900 fade-in-up">{name}</h5>
                    {tit2}
                </a>
            ) : (
                <div className="px-5 pt-3">
                    <h5 className="text-2xl font-bold tracking-tight text-gray-900 fade-in-up">{name}</h5>
                    {tit2}
                </div>
            )}

            <p class="px-5 mt-2  text-lg font-normal text-gray-700 flex-grow">{description}</p>

            <div class="px-8 mb-2 mt-auto">
                {new_banner}
                {catalog_btn}
                {manual_btn}
                {demo_btn}
            </div>
        </div>
    )
}